import { useState } from 'react';
import {
  DataGridBody,
  DataGridRow,
  DataGrid,
  DataGridHeader,
  DataGridHeaderCell,
  DataGridCell,
  createTableColumn
} from '@fluentui/react-components';
import { getReasonLabel } from '../constants/reasons';

const makeItems = (recipes) => {
  return recipes.map(({ id, name, updatedAt, currentTarget, currentThresholdMin, currentThresholdMax, currentReason, currentComment }) => ({
    id: { label: id },
    name: { label: name },
    updatedAt: {
      label: new Date(updatedAt).toLocaleString(),
      timestamp: new Date(updatedAt).getTime()
    },
    thresholdMin: { label: currentThresholdMin.toString() },
    target: { label: currentTarget.toString() },
    thresholdMax: { label: currentThresholdMax.toString() },
    reason: { label: getReasonLabel(currentReason) },
    comment: { label: currentComment }
  }));
};

const columns = [
  createTableColumn({
    columnId: "recipe",
    compare: (a, b) => parseInt(a.id.label) - parseInt(b.id.label),
    renderHeaderCell: () => <strong>Recette</strong>,
    renderCell: (item) => `${item.name.label} (${item.id.label})`
  }),
  createTableColumn({
    columnId: "thresholdMin",
    compare: (a, b) => parseFloat(a.thresholdMin.label) - parseFloat(b.thresholdMin.label),
    renderHeaderCell: () => <strong>Seuil Min</strong>,
    renderCell: (item) => item.thresholdMin.label
  }),
  createTableColumn({
    columnId: "target",
    compare: (a, b) => parseFloat(a.target.label) - parseFloat(b.target.label),
    renderHeaderCell: () => <strong>Cible</strong>,
    renderCell: (item) => item.target.label
  }),
  createTableColumn({
    columnId: "thresholdMax",
    compare: (a, b) => parseFloat(a.thresholdMax.label) - parseFloat(b.thresholdMax.label),
    renderHeaderCell: () => <strong>Seuil Max</strong>,
    renderCell: (item) => item.thresholdMax.label
  }),
  createTableColumn({
    columnId: "reason",
    renderHeaderCell: () => <strong>Raison</strong>,
    renderCell: (item) => item.reason.label
  }),
  createTableColumn({
    columnId: "comment",
    renderHeaderCell: () => <strong>Commentaire</strong>,
    renderCell: (item) => item.comment.label
  }),
  createTableColumn({
    columnId: "updatedAt",
    compare: (a, b) => a.updatedAt.timestamp - b.updatedAt.timestamp,
    renderHeaderCell: () => <strong>Dernière Modification</strong>,
    renderCell: (item) => item.updatedAt.label
  })
];

const columnSizingOptions = {
  recipe: {
    idealWidth: 160,
  },
  thresholdMin: {
    idealWidth: 40
  },
  target: {
    idealWidth: 40
  },
  thresholdMax: {
    idealWidth: 40
  },
  reason: {
    idealWidth: 150
  },
  comment: {
    idealWidth: 160
  },
  updatedAt: {
    minWidth: 160
  }
};

const RecipesTargetTable = ({ recipes, selectedId, onSelect }) => {
  const [selectedRows, setSelectedRows] = useState(selectedId ? new Set([parseInt(selectedId)]) : new Set([]));

  const onSelectionChange = (_, data) => {
    setSelectedRows(data.selectedItems);
    onSelect(data.selectedItems.values().next().value);
  };

  return (
    <DataGrid
      items={makeItems(recipes)}
      columns={columns}
      selectionMode="single"
      selectionAppearance="neutral"
      selectedItems={selectedRows}
      onSelectionChange={onSelectionChange}
      sortable
      getRowId={(item)=> item.id.label}
      resizableColumns
      columnSizingOptions={columnSizingOptions}
      resizableColumnsOptions={{autoFitColumns: true}}
    >
      <DataGridHeader>
        <DataGridRow>
          {({ renderHeaderCell }) => (
            <DataGridHeaderCell>{renderHeaderCell()}</DataGridHeaderCell>
          )}
        </DataGridRow>
      </DataGridHeader>
      <DataGridBody>
        {({ item, rowId }) => (
          <DataGridRow key={rowId}>
            {({ renderCell }) => (
              <DataGridCell>{renderCell(item)}</DataGridCell>
            )}
          </DataGridRow>
        )}
      </DataGridBody>
    </DataGrid>
  );
};

export default RecipesTargetTable;
